<template>
<!-- 用户协议 -->
    <div class="privacy">
        <h3>
            {{$t('lang.vip.userAgreement')}}
        </h3>
        <div v-for="(item, index) in privacy">
            <h4>
                {{item.title}}
            </h4>
            <p v-for="(itemC, index) in item.content">
                {{itemC}}
            </p>
            <br/>
        </div>
        
</div>
</template>

<script>
export default {
  name: 'home',
  data(){
    return {
      privacy: []
    }
  },
  beforeMount: function(){
      this.privacy = this.$t('lang.vip.privacy')
  }
}
</script>

<style scoped lang="less">
.privacy{
    position:fixed;
  left:0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  color: #000;
  padding: .2rem .4rem;
  overflow: scroll;
  h4{
      font-size: .373rem;
    padding-bottom: .1rem;
  }
  p{
        text-indent: .3rem;
    }
}
</style>